import axiosInstance from "../../../interceptor/intercetptor-inctence";
import { secureApiFormDataRequest, secureApiRequest } from "../../../Services/secureApiRequest";

export const listAPI = (data) => {
    // return axiosInstance.post(`clinic_admin/non_clinic_users`, data);
    return secureApiRequest("post", `pharma/getCashierList`, data);
}

export const getSubAdminListAPI = (data) => {
    // return axiosInstance.post(`clinic_admin/non_clinic_users/create`, data);
    return axiosInstance.post(`healthcare_providers/subadmin/getList`, data);
}

// export const createAPI = (data, file) => {
//     // return axiosInstance.post(`clinic_admin/non_clinic_users/create`, data);
//     return secureApiFormDataRequest("post", `clinic_admin/non_clinic_users/create`, data, file);
// }
export const createCashier = (data) => {
    // return axiosInstance.post(`clinic_admin/non_clinic_users/create`, data);
    return axiosInstance.post(`pharma/createCashier`, data);
}

export const createSubAdmin = (data) => {
    // return axiosInstance.post(`clinic_admin/non_clinic_users/create`, data);
    return axiosInstance.post(`healthcare_providers/subadmin/create`, data);
}

export const getCashierDetails = (data) => {
    // return axiosInstance.post(`clinic_admin/non_clinic_users/create`, data);
    return axiosInstance.post(`pharma/getCashierProfile`, data);
}

export const getSubAdminDetails = (data) => {
    // return axiosInstance.post(`clinic_admin/non_clinic_users/create`, data);
    return axiosInstance.post(`healthcare_providers/subadmin/getProfile`, data);
}


export const updateCashierDetails = (data) => {
    // return axiosInstance.post(`clinic_admin/non_clinic_users/create`, data);
    return axiosInstance.post(`pharma/updateCashier`, data);
}

export const updateSubAdminDetails = (data) => {
    // return axiosInstance.post(`clinic_admin/non_clinic_users/create`, data);
    return axiosInstance.post(`healthcare_providers/subadmin/update`, data);
}

export const getStaffShiftHistory = (data) => {
    // return axiosInstance.post(`clinic_admin/non_clinic_users/create`, data);
    return axiosInstance.post(`pharma/shiftHistoyList`, data);
}

export const getStaffShiftHistoryDetails = (data) => {
    // return axiosInstance.post(`clinic_admin/non_clinic_users/create`, data);
    return axiosInstance.post(`pharma/getShiftHistory`, data);
}


export const getData = (id) => {
    // return axiosInstance.get(`clinic_admin/non_clinic_users/get/${id}`);
    return secureApiRequest("get", `clinic_admin/non_clinic_users/get/${id}`);
}

export const updateAPI = (data, file) => {
    // return axiosInstance.post(`clinic_admin/non_clinic_users/update`, data);
    return secureApiFormDataRequest("post", `clinic_admin/non_clinic_users/update`, data, file);
}

export const staffsMaster = () => {
    return axiosInstance.get(`masters/staffs`)
}
